
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Vocal</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Classical And Semi <span > Classical Vocal</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">VIDUSHI KALAPINI KOMKALI <span class="small-sm"> 25 OCTOBER 2019</span></h2>
                    <h6 class="fw-bold">(DAUGHTER AND DISCIPLE OF THE LEGENDARY PANDIT KUMAR GANDHARVA AND VIDUSHI
                        VASUNDHARA KOMKALI)</h6>
                    <p>Endowed with wholly original, melodious and extremely rich voice, Kalapini is widely recognized
                        as one of the finest and well - trained classical vocalists of the younger generation. She is
                        the daughter and disciple of legendary Pandit Kumar Gandharva and has also been trained by her
                        illustrious mother, Vidushi Vasundhara Komkali. Kalapini learnt from her distinguished parents
                        not only the technique and grammar of her art but also inherited a capacity for creativity and
                        reflection.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v-1.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <p>While strengthening her hold over her inheritance with fine sense of understanding, she has evolved her
                own vision and has emerged in last decade as a vocalist with a profound degree of sensitivity and
                intensity. Her performances are marked by youthful imagination, artistic thoughtfulness and a mature
                command over various aspects of classical vocalism.</p>
            <p>Her musical lineage is most manifest in the emphasis laid on the rendition of the bandish (composition),
                its bhava or meaning, and in the studied restraint which does not allow the notes, or laya (tempo), to
                overwhelm the lyrics. The full melodic range and versatility of the voice provides a silhouette but they
                never are allowed to dominate the rendition by naturally sliding into vocal acrobatics.</p>
            <p>Her range of swaras has ability to convey various bhavas (emotions). The improvisations made by her are
                generally rooted in Gwalior gayaki, but carry her own distinct identity. Kalapini's wide repertoire of
                ragas and compositions is further supplemented by the presentation of the traditional songs of Malwa
                representing the folkore and ethnic scent of the region. The Sagun-Nirgun bhajans (devotional songs) of
                the various saint poets rendered in her inimitable style provide the acetic flavor to Kalapini's music.
                Committed to the promotion of art, she organizes music festivals at Dewas to bring together major
                scholars, performers as well as young artists. Performer of uncommon perception, Kalapini is popular
                amongst the youth for her lecture- demonstrations of Indian Classical Music.</p>
            <p>Kalapini lives in Dewas, Central India. She is an active trustee of Kumar Gandharva Sangeet Academy. She
                has received a fellowship from Dept. of Culture, Government of India and has been honoured with the
                Kumar Gandharva Award by the prestigious Pujari Pratishthan of Pune. Commercial releases of her studio
                recordings include, 'Aarambha' and 'Inheritence', released by HMV; and 'Dharohar' released by Times
                Music. 'Swar- Manjari', a live concert recording, was released recently by Virgin Records. Kalapini has
                also recorded for sound tracks of films, 'Paheli' and 'Devi Ahilya'. (Source https://www.kalapini.com)
                On 25th October @ 6.00 Pm. Vidushi Kalapini Komkali in the Classical Conclave session at Chitnavis
                Centre Nagpur.</p>
        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-8">
                <h6 class="fw-bold">Let’s meet you then.</h6>
                <p class="fw-bold"> Classical and Semi Classical Vocal</p>
                <p>Date : 25 <sup>th</sup> December 2019</p>
                <p>Time : 6.00 Pm</p>
                <p>Venue : Chitnavis Centre, Beside Hislop College, Civil Lines Nagpur.</p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <h6 class="fw-bold"> INVITATION</h6>
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/VidushiKomkali-Invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230" src="https://urlzs.com/xf6hs" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230" src="https://www.youtube.com/embed/_TQYpWXxZKc" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#aditi-upadhya" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/v_7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>
        </div>

    </div>
</section>
